module.exports = __webpack_public_path__ + "img/kcg-logo.2098b853.png";